export default "assets/images/orias-546c0cbf.png";